import React from "react";
import { Alert, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
export default function RetailPromotionNotice({ offer }) {
    const { i18n } = useTranslation();
    const ar = i18n.language?.startsWith("ar");
    if (!offer) return null;
    return (
        <Alert severity="success" sx={{ my: 1 }}>
            <Typography fontWeight={700}>{offer.title}</Typography>
            <div>
                {ar ? "قيمة التوفير" : "Savings"}:{" "}
                {Number(offer.savings).toFixed(2)}
            </div>
            {Object.entries(offer.gifts || {}).map(([code, qty]) => (
                <div key={code}>
                    {qty} × {code} —{" "}
                    {ar ? "هدية مجانية إضافية" : "extra free gift"}
                </div>
            ))}
            <small>
                {ar
                    ? "أفضل عرض فقط؛ لا يمكن دمجه مع خصومات أخرى."
                    : "Best offer applied. Additional discounts do not apply."}
            </small>
        </Alert>
    );
}
